import InfiniteScroll from 'infinite-scroll';

const appendToElementClassName = '.news-listing__grid.o-layout > .o-layout__item';
const showMoreBtnClassName = '.load-more-button-container a';

export default () => {
	if ( !document.querySelector(appendToElementClassName)
		|| !document.querySelector(showMoreBtnClassName) ) {
		return false;
	}

	return new InfiniteScroll('.news-listing__grid', {
		path: showMoreBtnClassName,
		append: appendToElementClassName,
		status: undefined,
		scrollThreshold: false,
		button: showMoreBtnClassName,
		onInit: undefined,
	});
}